export enum DATE_TIME_PICKER_TIMEZONES {
  SYSTEM = 'system',
  NEW_YORK = 'America/New_York',
  LA = 'America/Los_Angeles',
  CHICAGO = 'America/Chicago',
  LONDON = 'Europe/London',
}
